module.exports = __webpack_public_path__ + "52e5ef9d2c53d8ce2b4fe32aa63c82c4.pdf";